const getSingleAttributeName = ({attributes, attribute}) => {
  const selectedAttribute = [...attributes].find(
    (existingAttribute) => existingAttribute.value === attribute
  );
  return selectedAttribute?.label || attribute;
};

// A requirement entry is either a plain field name, or an array of field names
// meaning "any one of these" (an OR-group) - join their labels for display.
const getAttributeName = ({attributes, attribute}) =>
  Array.isArray(attribute)
    ? attribute
        .map((member) => getSingleAttributeName({attributes, attribute: member}))
        .join(' OR ')
    : getSingleAttributeName({attributes, attribute});

export default getAttributeName;
